/**
 * TaskCommentService
 * Service for TaskComment entity operations
 * Route: api/task-comment
 */
import { CrudService } from '../base/CrudService';
/**
 * TaskCommentService
 * Handles task comment CRUD operations and comment views
 */
export class TaskCommentService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? TaskCommentService.DEFAULT_SERVICE_PATH,
            basePath: TaskCommentService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET ALL VIEWS ====================
    /**
     * Get all comment views
     * GET api/task-comment/view
     */
    async getAllViews() {
        const response = await this.getAllViewsRaw();
        return response.data ?? [];
    }
    /**
     * Get all comment views with full response
     */
    getAllViewsRaw() {
        const endpoint = this.getEndpoint('all-views', 'view');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== GET BY TASK ID ====================
    /**
     * Get all comments for a task
     * GET api/task-comment/task/{taskId}
     */
    async getByTaskId(taskId) {
        const response = await this.getByTaskIdRaw(taskId);
        return response.data ?? [];
    }
    /**
     * Get all comments for a task with full response
     */
    getByTaskIdRaw(taskId) {
        const endpoint = this.getEndpoint('by-task', `task/${taskId}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== GET VIEWS BY TASK ID ====================
    /**
     * Get comment views for a task
     * GET api/task-comment/task/{taskId}/view
     */
    async getViewsByTaskId(taskId) {
        const response = await this.getViewsByTaskIdRaw(taskId);
        return response.data ?? [];
    }
    /**
     * Get comment views for a task with full response
     */
    getViewsByTaskIdRaw(taskId) {
        const endpoint = this.getEndpoint('views-by-task', `task/${taskId}/view`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== GET VIEW BY ID ====================
    /**
     * Get comment view by ID
     * GET api/task-comment/view/{id}
     */
    async getViewById(id) {
        const response = await this.getViewByIdRaw(id);
        if (!response.data) {
            throw new Error(`Comment view ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get comment view by ID with full response
     */
    getViewByIdRaw(id) {
        const endpoint = this.getEndpoint('view-by-id', `view/${id}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
}
TaskCommentService.DEFAULT_SERVICE_PATH = 'tasks';
TaskCommentService.BASE_PATH = 'api/task-comment';
//# sourceMappingURL=TaskCommentService.js.map